import { MenuProps } from "antd";

export const ZERO_ADDRESS = "0x0000000000000000000000000000000000000000";
export const evmChain = [12306];
export const chainParams: any = {
  12306: {
    chainId: 12306,
    chainName: "Fibochain", // 自定义链的名称
    nativeCurrency: {
      name: "FIBO",
      symbol: "FIBO",
      decimals: 18,
    },
    rpcUrls: ["https://node1.fibo-rpc.asia"],
    blockExplorerUrls: ["https://scan.fibochain.org/"],
  },
  56: {
    chainId: 56,
    chainName: "BSC",
    nativeCurrency: {
      name: "BNB",
      symbol: "BNB",
      decimals: 18,
    },
    rpcUrls: ["https://bsc-dataseed.binance.org/"],
    blockExplorerUrls: ["https://bscscan.com"],
  },
  97: {
    chainId: 97,
    chainName: "BSC Testnet",
    nativeCurrency: {
      name: "BNB",
      symbol: "BNB",
      decimals: 18,
    },
    rpcUrls: ["https://bsc-testnet-rpc.publicnode.com"],
    blockExplorerUrls: ["https://testnet.bscscan.com/"],
  },
};
// 代币符号
export const SYMBOL = "NFX";
export const MAINNET_SYMBOL = "FIBO";
// 桥链接
export const BRIDGE_LINK = "https://bridge.nfx-rwa.org/";
// 联系链接
export const CONTACT_LINK = {
  officialWebsite: "https://www.nfx-rwa.org",
  twitter: "http://x.com/NfxFinance",
  telegram: "https://t.me/NFXGlobalCommunity",
  discord: "https://discord.gg/3U4Xpyv6hA",
};
// 语言选项
export const languageItems: MenuProps["items"] = [
  {
    key: "zh",
    label: "中文",
  },
  {
    key: "en",
    label: "English",
  },
  {
    key: "ja",
    label: "わぶん",
  },
  {
    key: "ko",
    label: "한국어",
  },
];
// 流动算力数据
export const hashrateData = [
  {
    m: "",
    y: "",
    min: 200,
    max: 30000,
  },
  {
    m: "0.8T",
    y: "9.6T",
    min: 200,
    max: 1000,
  },
  {
    m: "1.0T",
    y: "12T",
    min: 1000,
    max: 5000,
  },
  {
    m: "1.2T",
    y: "14.4T",
    min: 5000,
    max: 10000,
  },
  {
    m: "1.8T",
    y: "21.6T",
    min: 10000,
    max: 20100,
  },
  {
    m: "3.0T",
    y: "36T",
    min: 20100,
    max: 30000,
  },
];
// 合约算力数据
export const selectList = [
  {
    label: `30`,
    value: 30,
    coreCount: "3.0T",
    multiple: "1.5",
    min: 200,
    max: 1000,
    unlockCycle: 2592000,
  },
  {
    label: `90`,
    value: 90,
    coreCount: "6.0T",
    multiple: "2.0",
    min: 200,
    max: 5000,
    unlockCycle: 7776000,
  },
  {
    label: `180`,
    value: 180,
    coreCount: "8.0T",
    multiple: "2.5",
    min: 200,
    max: 10000,
    unlockCycle: 15552000,
  },
  {
    label: `360`,
    value: 360,
    coreCount: "10.0T",
    multiple: "3.0",
    min: 200,
    max: 20000,
    unlockCycle: 31104000,
  },
  {
    label: `720`,
    value: 720,
    coreCount: "15.0T",
    multiple: "4.0",
    min: 200,
    max: 30000,
    unlockCycle: 62208000,
  },
];
